import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateTicketDialogComponent } from '../../components/create-ticket-dialog/create-ticket-dialog.component';
import { AppService } from '../app/app.service';
import { Ticket } from '../../classes/ticket';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TicketsystemService {
    private readonly neuesTicketErstellt = new Subject<Ticket>();

    constructor(
        private readonly dialog: MatDialog,
        private readonly appService: AppService,
    ) {}

    watchNeuesTicketErstellt(): Observable<Ticket> {
        return this.neuesTicketErstellt;
    }

    setNeuesTicketErstellt(ticket: Ticket) {
        this.neuesTicketErstellt.next(ticket);
    }

    async openCreateTicketDialog(errorObjectUrl?: string): Promise<void> {
        const isMobile: boolean = this.appService.isMobileScreen;
        let frame: string;

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const video = document.createElement('video');

        const displayMediaOptions = { video: true, preferCurrentTab: true };

        if (!isMobile) {
            try {
                const captureStream = await navigator.mediaDevices.getDisplayMedia(displayMediaOptions);
                video.srcObject = captureStream;

                await new Promise(resolveVideo => {
                    video.onloadedmetadata = () => {
                        video.play();
                        resolveVideo(null);
                    };
                });

                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;

                context.drawImage(video, 0, 0, canvas.width, canvas.height);
                frame = canvas.toDataURL('image/png');

                captureStream.getTracks().forEach(track => track.stop());
            } catch (err) {
                console.error('Error capturing screen:', err);
            }
        }

        this.dialog.open(CreateTicketDialogComponent, {
            width: '100%',
            data: { screenshot: frame, errorObjectUrl: errorObjectUrl },
        });
    }
}
